import { z } from "zod";
import { PAKISTAN_PROVINCES } from "../constants/provinces.js";

export const upsertShippingRateSchema = z.object({
  id: z.string().optional(),
  province: z.enum(PAKISTAN_PROVINCES),
  // null = catch-all tier for anything heavier than every other tier set for this province.
  maxWeightGrams: z.number().int().positive().nullable(),
  priceCents: z.number().int().min(0)
});
export type UpsertShippingRateInput = z.infer<typeof upsertShippingRateSchema>;
